import React, { Component } from 'react'
import { shape, string } from 'prop-types'
import { Alert } from '../LegacyComponents'

export default class MissingComponent extends Component {
  static propTypes = {
    name: string.isRequired,
    label: string.isRequired,
    component: string.isRequired,
    value: string,
    input: shape({
      value: string
    })
  }

  static defaultProps = {
    value: '',
    input: {}
  }

  render () {
    const {
      name,
      label,
      component,
      input: { value: inputValue },
      value
    } = this.props
    return (
      <div className="form__field">
        <div className="field__content">
          <label htmlFor={name}>{label}</label>
          <Alert type="error">"{component}" is not registered</Alert>
          <input
            type="hidden"
            name={name}
            id={name}
            defaultValue={inputValue || value}
          />
        </div>
      </div>
    )
  }
}
